<template>
	<div>
		<div class="flex justify-between lg:justify-end items-center">
			<div class="lg:hidden">Gesamt:</div>
			<div class="lg:text-right">{{ (item?.price?.gross * item?.quantity).toFixed(2) }}&nbsp;€</div>
		</div>
	</div>
</template>

<script setup lang="ts">
defineProps<{ 
	item: OrderItem;
}>()
</script>
